import script from "./NoResults.vue?vue&type=script&setup=true&lang=js"
export * from "./NoResults.vue?vue&type=script&setup=true&lang=js"

import "./NoResults.vue?vue&type=style&index=0&id=33aac960&lang=scss&scoped=true"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33aac960"]])

export default __exports__